
























import SelectPanel from '@/components/common/SelectPanel.vue'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { getDataName, getSelectDataMenu, getSelectIdList } from '@/request/apis/common'

@Component({
  components: {
    SelectPanel
  }
})

export default class CascaderSelect extends Vue {
  @Prop({ required: true }) type!: string
  @Prop({ required: true }) id!: string

  private curChooseData: string[] = []
  private cascaderKey: number = 0
  private cascaderProps: any = {
    lazy: true,
    lazyLoad: this.lazyLoads
  }
  private lazyLoadData: any = []
  private projectName: string = ''
  private module: string = ''

  /**
   * 级联选择器 懒加载
   */
  private async lazyLoads (node: any, resolve: any) {
    const { level, label } = node
    if (level === 0) { // 一级选择器的生成
      this.lazyLoadData = await getSelectDataMenu(null, this.type).start()
      let nodes = Array.from(this.lazyLoadData).map((item: any) => ({
        value: item.project_name,
        label: item.project_name,
        leaf: node.level >= 2
      }))
      resolve(nodes)
    } else if (level === 1) { // 一级选择器的子节点生成
      this.projectName = label
      let data: any = Array.from(this.lazyLoadData).find((item: any) => item.project_name === this.projectName)
      let nodes = data.modules.map((item: any) => ({
        value: item,
        label: item,
        leaf: node.level >= 2
      }))
      resolve(nodes)
    } else if (level === 2) { // 三级选择器的生成
      this.module = label
      let data = await getSelectIdList(null, this.projectName, this.module).start()
      let nodes = Array.from(data).map(item => ({
        value: item,
        label: item,
        leaf: level >= 2
      }))
      resolve(nodes)
    }
  }

  /**
   * 选择器 change事件
   */
  private handleChange (value: string[]) {
    this.$emit('data-change', value[value.length - 1])
  }

  /**
   *  获取上一步选择的数据
   */
  @Watch('id', { immediate: true })
  async defaultDataChanged (val: string) {
    if (val) {
      const res = await getDataName(null, val).start()
      this.curChooseData = res.split('/')
      this.$emit('data-change', this.curChooseData)
      this.cascaderKey++ // 更新级联组件，有时value值拿到但未渲染
    }
  }

}
